import _defineProperty from '@babel/runtime/helpers/defineProperty';
import DynamicIcon from './Functional/DynamicIcon.js';
import FluidMaxContainer from './FluidMaxContainer.js';
import Input from './Input.js';
import WizardCard from './WizardCard.js';
import WizardHeading from './WizardHeading.js';
import StartLayoutContainer from './Layouts/StartLayoutContainer.js';
import UserDataStepLayoutContainer from './Layouts/UserDataStepLayoutContainer.js';
import RendererLayoutContainer from './Layouts/RendererLayoutContainer.js';
import NavigationButtonsLayoutContainer from './Layouts/NavigationButtonsLayoutContainer.js';
import CalculationLayoutContainer from './Layouts/CalculationLayoutContainer.js';
import ChoiceOptionColContainer from './Layouts/ChoiceOptionColContainer.js';
import ChoiceOptionRowContainer from './Layouts/ChoiceOptionRowContainer.js';
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/**
 * Provides all base Components
 */
var components = {
  DynamicIcon: DynamicIcon,
  FluidMaxContainer: FluidMaxContainer,
  Input: Input,
  WizardCard: WizardCard,
  WizardHeading: WizardHeading,
  StartLayoutContainer: StartLayoutContainer,
  UserDataStepLayoutContainer: UserDataStepLayoutContainer,
  RendererLayoutContainer: RendererLayoutContainer,
  NavigationButtonsLayoutContainer: NavigationButtonsLayoutContainer,
  CalculationLayoutContainer: CalculationLayoutContainer,
  ChoiceOptionColContainer: ChoiceOptionColContainer,
  ChoiceOptionRowContainer: ChoiceOptionRowContainer
};
var getComponents = function getComponents(customComponents) {
  return _objectSpread(_objectSpread({}, components), customComponents);
};
export { components, getComponents };